import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageEditor/post-list.vue'
createPage(Page)